import _implicitStylesheets from "./mulesoftIcon.css";
import _implicitScopedStylesheets from "./mulesoftIcon.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<svg${"a0:width"}${"a0:height"} viewBox="0 0 62 62" version="1.1"${3}><title${3}>${"t2"}</title><g${"a3:id"} stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"${3}><g${"a4:id"}${3}><path d="M10.1451 32.5418C10.0593 20.3573 19.927 10.4896 32.1115 10.4038C44.2961 10.3179 54.1638 20.1857 54.2496 32.2844V32.3702C54.2496 44.5547 44.3819 54.4225 32.2832 54.4225C20.0986 54.5083 10.2309 44.7263 10.1451 32.5418Z" fill="#0D9DDA"${3}/><path d="M20.0138 33.0564C20.0138 30.8255 20.7002 28.5945 21.9015 26.7067L29.7957 38.548H34.6009L42.4951 26.7067C43.6964 28.5945 44.3828 30.8255 44.3828 33.0564C44.3828 37.0035 42.3235 40.6932 38.977 42.7525L40.5215 48.5874C49.3596 43.9538 52.8777 33.0564 48.2441 24.1325C46.6996 21.1293 44.3828 18.6409 41.4654 16.9248L32.2841 31.1687L23.1886 16.9248C14.608 21.9874 11.6906 33.0564 16.839 41.6371C18.7267 44.7261 21.4725 47.3003 24.7332 48.8448L26.1919 43.0958C22.4164 41.208 20.0138 37.2609 20.0138 33.0564Z" fill="white"${3}/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.25781 32.2839C8.25781 45.5839 18.9836 56.3097 32.2836 56.3097C45.5836 56.3097 56.3094 45.5839 56.3094 32.2839C56.3094 18.9839 45.5836 8.25806 32.2836 8.25806C18.9836 8.25806 8.25781 18.9839 8.25781 32.2839ZM10.1456 32.5413C10.0597 20.3568 19.9275 10.489 32.112 10.4032C44.2965 10.3174 54.1643 20.1852 54.2501 32.2839V32.3697C54.2501 44.5542 44.3823 54.4219 32.2836 54.4219C20.0991 54.5077 10.2314 44.7258 10.1456 32.5413Z" fill="#032D60"${3}/></g></g></svg>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, gid: api_scoped_id, sp: api_static_part, st: api_static_fragment} = $api;
  return [api_static_fragment($fragment1, 1, [api_static_part(0, {
    attrs: {
      "width": $cmp.width,
      "height": $cmp.height
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.alternativeText)), api_static_part(3, {
    attrs: {
      "id": api_scoped_id("AXPL-product-icons-/-mulesoft")
    }
  }, null), api_static_part(4, {
    attrs: {
      "id": api_scoped_id("Icon")
    }
  }, null)])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-18u5o813uh3";
tmpl.legacyStylesheetToken = "appx-productIcons_mulesoftIcon";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
